export default __webpack_public_path__ + "static/media/logo.71ef1e7d.png";